import { toAddressDetail, toSingleLineAddress } from '@belong/domain-address-capture';
import {
  ILegacyServiceQualificationAddress,
  ILegacyTelstraAddress,
  INbnOrderAddress,
  IServiceQualificationAddress,
  ISqModel,
  ITelstraAddress
} from '@belong/types';
import { withBasePath } from '@belong/url-utils';
import { ADDRESS_CHECK_ANCHOR_ID, getDisplayAddress } from './orderSummary';

//  Strips any existing hash so appending the anchor doesn't produce a double hash.
export const getAddressCheckHref = (asPath: string): string =>
  `${withBasePath(asPath.split('#')[0])}#${ADDRESS_CHECK_ANCHOR_ID}`;

export const makePartialAddressFromStrategicAddressEntity = (
  addressEntity: IServiceQualificationAddress | ILegacyServiceQualificationAddress
): string => {
  const { subAddress, streetNumber, streetName, streetType } = addressEntity;
  if (subAddress) {
    return `${subAddress ?? ''}, ${streetNumber ?? ''} ${streetName ?? ''} ${streetType ?? ''}`;
  }

  return `${streetNumber ?? ''} ${streetName ?? ''} ${streetType ?? ''}`;
};

export const makeFullAddressFromStrategicAddressEntity = (
  addressEntity?:
    | IServiceQualificationAddress
    | ILegacyServiceQualificationAddress
    | INbnOrderAddress
    | ILegacyTelstraAddress
    | ITelstraAddress
): string => {
  if (!addressEntity) {
    return '';
  }

  // Address may be sourced from out of date localstorage, so try to convert to IAddressDetail
  return toSingleLineAddress(toAddressDetail(addressEntity));
};

export const getDisplayAddressInSqModel = (sqModel?: ISqModel): string => {
  if (!sqModel) {
    return '';
  }

  const serviceAddress = sqModel?.serviceAddress;
  // If the address entity has 'locality', it's a Telstra address
  return serviceAddress && 'locality' in serviceAddress
    ? toSingleLineAddress(serviceAddress)
    : getDisplayAddress(sqModel);
};
